import { useApi } from '@/api';
import { LinkButton } from '@/components';
import {
  HeatmapActivity,
  HeatmapSkeleton,
  useIsMobile,
  Flex,
  FlexProps,
  Heading
} from '@blockanalitica/ui';
import { HeatmapData } from '@blockanalitica/ui/package/types/src/components/charts/Heatmap/Heatmap';
import { useNavigate } from 'react-router';
import { useTheme } from 'styled-components';

interface ActivityProps extends FlexProps {
  url: string;
  linkTo: string;
  onClickUrl?: string | undefined;
  color?: string;
}

export default function ActivityCard({
  url,
  linkTo,
  color,
  onClickUrl = undefined,
  ...rest
}: ActivityProps) {
  const isMobile = useIsMobile();
  const daysAgo = isMobile ? 120 : 365;
  const [data, error] = useApi<HeatmapData[]>({
    url: url,
    queryParams: {
      days_ago: daysAgo
    }
  });

  const theme = useTheme();
  const navigate = useNavigate();

  function onClickCallback(
    //@ts-ignore
    e: React.MouseEvent<HTMLTableCellElement, MouseEvent>,
    { date }: HeatmapData
  ) {
    navigate(`${onClickUrl}?date=${date.split('T')[0]}`, { relative: 'path' });
  }

  if (error) throw error;

  if (!data) {
    return <HeatmapSkeleton />;
  }

  return (
    <Flex flexDirection="column" {...rest}>
      <HeatmapActivity
        title={<Heading size="2">Activity</Heading>}
        action={
          <LinkButton variant="whiteAndUgly" fontSize="-1" to={linkTo}>
            View all
          </LinkButton>
        }
        data={data}
        daysAgo={daysAgo}
        options={{
          heatColor: color || theme.colors.primary,
          onClickCallback: onClickUrl ? onClickCallback : undefined
        }}
      />
    </Flex>
  );
}
